import React, { useMemo } from 'react';
import "./CompactTable.scss";
import Label from '../Label/Label';
import UnstyledButton from '../UnstyledButton/UnstyledButton';
import Visage2Icon from '../Visage2Icon/Visage2Icon';

interface ICompactTableButton {
    title: string;
    icon: string;
    onClick: () => void;
}

interface IProps {
    columNames: string[];
    rows: string[][];
    renderOptions?: (index: number) => any;
    buttons?: ICompactTableButton[][];
    multiRow?: boolean;
};

const CompactTable = (props: IProps) => {
    const classNames = useMemo(() => {
        const result = ["CompactTable"];

        if (props.multiRow) {
            result.push("multi-row")
        }

        return result;
    }, [props.multiRow]);

    return (
        <div className={classNames.join(" ")}>
            <div className="row title">
                {props.columNames.map((name: string, columnIndex: number) => {
                    return (
                        <div className="column" key={columnIndex}>
                            <Label size="body-2" color="p-mid-grey-1">{name}</Label>
                        </div>
                    )
                })}
                {!!props.renderOptions && <div className="menu-faker" />}
                {!!props.buttons && <div className="buttons-faker" />}
            </div>
            <div>
                {props.rows.map((row: string[], rowIndex: number) => {
                    const rowButtons = props.buttons[rowIndex];

                    return (
                        <div className="row" key={rowIndex}>
                            {row.map((value: string, columnIndex: number) => {
                                return (
                                    <div className="column" key={columnIndex}>
                                        <Label size="body-2">{value}</Label>
                                    </div>
                                )
                            })}
                            {!!props.renderOptions && props.renderOptions(rowIndex)}
                            {!!rowButtons && rowButtons.length > 0 && (
                                <div className="buttons">
                                    {rowButtons.map((item: ICompactTableButton, index: number) => {
                                        return (
                                            <UnstyledButton title={item.title} onClick={item.onClick} key={index}>
                                                <Visage2Icon icon={item.icon} size="small" />
                                            </UnstyledButton>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default CompactTable;
